import { gql } from '@apollo/client';

export const EXCHANGE_EMAIL_TOKEN = gql`
  mutation ExchangeEmailToken($token: String!) {
    exchangeEmailToken(token: $token)
  }
`;
